import useApi from './use-api'
import useCache from './use-cache'
import useCacheKeys from './use-cache-keys'
import useCurrentUser from './use-current-user'
import useToasts from './use-toasts'
import useClientLocation from './use-client-location'
import useConfirmationDialog from './use-confirmation-dialog'
import useSnooze from './use-snooze'
import useViewport from './use-viewport'
import useSystemSettings from './use-system-settings'

const hooks = {
    useApi,
    useCache,
    useCacheKeys,
    useCurrentUser,
    useToasts,
    useClientLocation,
    useConfirmationDialog,
    useSnooze,
    useViewport,
    useSystemSettings
}

export default hooks
